const API_BASE_URL = import.meta.env.DEV ? 'http://localhost:3000' : '';

export const getAllLicenses = async () => {
  const token = localStorage.getItem('authToken');
  
  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/licenses`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch licenses');
    }

    const data = await response.json();
    return data.licenses;
  } catch (error) {
    console.error('Error fetching all licenses:', error);
    throw error;
  }
};

export const getAllUsers = async () => {
  const token = localStorage.getItem('authToken');
  
  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/users`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch users');
    }

    const data = await response.json();
    return data.users;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const createLicense = async (email: string, cost: number, orderId: string) => {
  const token = localStorage.getItem('authToken');
  
  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/licenses/create`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email, cost, orderId })
    });

    if (!response.ok) {
      throw new Error('Failed to create license');
    }

    const data = await response.json();
    return data.license;
  } catch (error) {
    console.error('Error creating license:', error);
    throw error;
  }
};

export const deleteUser = async (userId: string) => {
  const token = localStorage.getItem('authToken');
  
  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/users/${userId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to delete user');
    }
  } catch (error) {
    console.error('Error deleting user:', error);
    throw error;
  }
};

export const updateUser = async (userId: string, data: { email?: string; isAdmin?: boolean }) => {
  const token = localStorage.getItem('authToken');
  
  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/users/${userId}`, {
      method: 'PATCH',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error('Failed to update user');
    }

    const updatedUser = await response.json();
    return updatedUser.user;
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
};

export const suspendUser = async (userId: string) => {
  const token = localStorage.getItem('authToken');
  
  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/users/${userId}/suspend`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to suspend user');
    }

    const data = await response.json();
    return data.user;
  } catch (error) {
    console.error('Error suspending user:', error);
    throw error;
  }
};

export const resetHWID = async (licenseKey: string) => {
  const token = localStorage.getItem('authToken');
  
  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/licenses/reset-hwid`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ licenseKey })
    });

    if (!response.ok) {
      throw new Error('Failed to reset HWID');
    }

    const data = await response.json();
    return data.license;
  } catch (error) {
    console.error('Error resetting HWID:', error);
    throw error;
  }
};

export const revokeLicense = async (licenseKey: string) => {
  const token = localStorage.getItem('authToken');
  
  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/licenses/revoke`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ licenseKey })
    });

    if (!response.ok) {
      throw new Error('Failed to revoke license');
    }

    const data = await response.json();
    return data.license;
  } catch (error) {
    console.error('Error revoking license:', error);
    throw error;
  }
};